import { isDate } from 'element-ui/src/utils/date-util'

export default {
    getOptions() {
        return {
            firstDayOfWeek: 1,
            shortcuts: [
                {
                    text: 'Heute',
                    onClick(picker) {
                        picker.$emit('pick', new Date())
                    }
                },
                {
                    text: 'Gestern',
                    onClick(picker) {
                        const date = new Date()
                        date.setDate(date.getDate() - 1)
                        picker.$emit('pick', date)
                    }
                },
                {
                    text: 'Letzte Woche',
                    onClick(picker) {
                        const date = new Date()
                        date.setDate(date.getDate() - 7 - (date.getDay() - 1))
                        picker.$emit('pick', date)
                    }
                },
                {
                    text: 'Dieser Monat',
                    onClick(picker) {
                        const date = new Date()
                        date.setDate(1)
                        picker.$emit('pick', date)
                    }
                },
                {
                    text: 'Letzter Monat',
                    onClick(picker) {
                        const date = new Date()
                        date.setMonth(date.getMonth() - 1)
                        date.setDate(1)
                        picker.$emit('pick', date)
                    }
                },
                {
                    text: 'Letzte 3 M',
                    onClick(picker) {
                        const date = new Date()
                        date.setMonth(date.getMonth() - 3)
                        date.setDate(1)
                        picker.$emit('pick', date)
                    }
                },
                {
                    text: 'Letzte 6 M',
                    onClick(picker) {
                        const date = new Date()
                        date.setMonth(date.getMonth() - 6)
                        date.setDate(1)
                        picker.$emit('pick', date)
                    }
                },
                {
                    text: 'Dieses Jahr',
                    onClick(picker) {
                        const date = new Date(new Date().getFullYear(), 0)
                        picker.$emit('pick', date)
                    }
                },
                {
                    text: 'Letztes Jahr',
                    onClick(picker) {
                        const date = new Date(new Date().getFullYear() - 1, 0)
                        picker.$emit('pick', date)
                    }
                }
            ]
        }
    },

    getOptionsDateRange(date, hasToBeGreater) {
        let options = this.getOptions()
        options.disabledDate = function (time) {
            if (!date) return false
            if (hasToBeGreater) {
                return time.getTime() < date
            } else {
                return time.getTime() > date
            }
        }
        return options
    },

    // golang echo returns datetime in UTC ISO 8601 format e.g. 2009-11-13T10:39:35Z
    // see https://stackoverflow.com/questions/1728404/date-format-yyyy-mm-ddthhmmssz
    formatUTCDateCH(utcDateString) {
        let d = new Date(utcDateString),
            month = d.getMonth() + 1,
            day = d.getDate()

        return [(day > 9 ? '' : '0') + day, (month > 9 ? '' : '0') + month, d.getFullYear()].join('.')
    },

    prettyDate(utcDateString) {
        const now = new Date()
        const date = new Date(utcDateString)
        const diff = now - date

        if (diff < 60000) {
            // Less than a minute
            return 'Just now'
        } else if (diff < 3600000) {
            // Less than an hour
            const minutes = Math.floor(diff / 60000)
            return minutes + (minutes > 1 ? ' minutes ago' : ' minute ago')
        } else if (diff < 86400000) {
            // Less than a day
            const hours = Math.floor(diff / 3600000)
            return hours + (hours > 1 ? ' hours ago' : ' hour ago')
        } else if (diff < 604800000) {
            // Less than a week
            const days = Math.floor(diff / 86400000)
            return days + (days > 1 ? ' days ago' : ' day ago')
        } else {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
            return date.toLocaleString('de-CH', options)
        }
    },

    formatUTCDateUS(utcDateString) {
        let d = new Date(utcDateString),
            month = d.getMonth() + 1,
            day = d.getDate()

        return [d.getFullYear(), (month > 9 ? '' : '0') + month, (day > 9 ? '' : '0') + day].join('-')
    },

    formatUTCDateTimeUS(utcDateTimeString) {
        let d = new Date(utcDateTimeString),
            month = d.getMonth() + 1,
            day = d.getDate(),
            hours = d.getHours(),
            minutes = d.getMinutes(),
            seconds = d.getSeconds()

        let dateString = [d.getFullYear(), (month > 9 ? '' : '0') + month, (day > 9 ? '' : '0') + day].join('-')

        let timeString = [(hours > 9 ? '' : '0') + hours, (minutes > 9 ? '' : '0') + minutes, (seconds > 9 ? '' : '0') + seconds].join(':')

        return dateString + 'T' + timeString + 'Z'
    },

    //code from element-ui
    getWeekNumber(d) {
        const date = new Date(d)
        date.setHours(0, 0, 0, 0)

        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7))

        // January 4 is always in week 1.
        const week1 = new Date(date.getFullYear(), 0, 4)

        // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
        // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7)
    },

    //solution from https://stackoverflow.com/questions/16590500/calculate-date-from-week-number-in-javascript
    getDateOfISOWeekAndYear(w, y) {
        let simple = new Date(y, 0, 1 + (w - 1) * 7),
            dow = simple.getDay(),
            IsoWeekStart = simple

        if (dow <= 4) {
            IsoWeekStart.setDate(simple.getDate() - simple.getDay() + 1)
        } else {
            IsoWeekStart.setDate(simple.getDate() + 8 - simple.getDay())
        }
        return IsoWeekStart
    }
}
